<template>
<div class="chapter">
<div class="inner_page">
<p><br/><br/><br/></p>
<p class="center"><i>For Bonnie</i><br/><i>and for our children</i>,<br/><i>Will and Emily</i></p>
<p class="pagebreak"></p>
<p><br/><br/><br/><br/></p>
<p><i>The mass and majesty of this world, all</i></p>
<p class="indent">        <i>That carries weight and always weighs the same</i></p>
<p><i>Lay in the hands of others; they were small</i></p>
<p class="indent">        <i>And could not hope for help, and no help came</i><br/><br/><br/><br/></p>
<p><i>W. H. Auden</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04ded.vue?739b3e2b